module.exports = __webpack_public_path__ + "img/pl.2d52144e.svg";